import { render } from "./Medico.vue?vue&type=template&id=dbb770a8&scoped=true"
import script from "./Medico.vue?vue&type=script&lang=js"
export * from "./Medico.vue?vue&type=script&lang=js"

import "./Medico.vue?vue&type=style&index=0&id=dbb770a8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb770a8"]])

export default __exports__